import { createSelector } from '@reduxjs/toolkit';
import { createStructuredSelector } from 'reselect';
import { extractFabrication } from 'us_full_feature_pcb/pcb_fabrication/slice/extractors';

export const selectFabricationParameters = (state) => state.fabrication?.parameters;
export const selectFabricationQuoteStep = (state) => state.fabrication?.quoteStep;
export const selectFabricationQuote = (state) => state.fabrication?.quote;
export const selectFabricationParametersChanged = (state) => state.fabrication?.parametersChanged;
export const selectFabricationProductToCompare = (state) => state.fabrication?.productToCompare;
export const selectFabricationLoading = (state) => state.fabrication?.loading;
export const selectFabricationValidatorFlag = (state) => state.fabrication?.validatorFlag;
export const selectFabricationCurrentVariant = (state) => state.fabrication?.currentVariant;
export const selectFabricationDestroy = (state) => state.fabrication?.destroy;
export const selectFabricationLineItemId = (state) => state.fabrication?.lineItemId;

export const selectFabricationDataForParameters = createStructuredSelector({
  quoteStep: selectFabricationQuoteStep,
  parameters: selectFabricationParameters,
  loading: selectFabricationLoading,
  validatorFlag: selectFabricationValidatorFlag,
});

export const selectFabricationDataForPrices = createStructuredSelector({
  quote: selectFabricationQuote,
  quoteStep: selectFabricationQuoteStep,
  parameters: selectFabricationParameters,
  parametersChanged: selectFabricationParametersChanged,
});

export const selectFabricationDataForActions = createStructuredSelector({
  quote: selectFabricationQuote,
  quoteStep: selectFabricationQuoteStep,
  productToCompare: selectFabricationProductToCompare,
  parametersChanged: selectFabricationParametersChanged,
  parameters: selectFabricationParameters,
});

export const selectFabricationDataForZipFile = createStructuredSelector({
  parameters: selectFabricationParameters,
  quoteStep: selectFabricationQuoteStep,
  destroy: selectFabricationDestroy,
  lineItemId: selectFabricationLineItemId,
});

export const selectFabricationDataForCart = createSelector(
  [
    selectFabricationParameters,
    selectFabricationQuoteStep,
    selectFabricationQuote,
    selectFabricationCurrentVariant,
    selectFabricationDestroy,
    selectFabricationLineItemId,
  ],
  (parameters, quoteStep, quote, currentVariant, destroy, lineItemId) => {
    const itemsToDestroy = destroy && lineItemId ? [lineItemId] : [];
    const dataForForms = { parameters, quoteStep, fabricationVariant: currentVariant };

    return {
      partNumber: parameters?.part_number,
      revision: parameters?.revision,
      fabricationToDestroy: itemsToDestroy,
      fabricationDataForForms: dataForForms,
      fabricationProps: extractFabrication({ quoteStep, parameters, quote }),
    };
  },
);
